import { PageContent } from "../pages/templates/PageLayout";

import Images from "../data/images";
import { MarketingButtons } from "../components/MarketingButtons";

const content: PageContent = {
  style: "dark",
  sections: [
    {
      type: "HeroSection",
      title: "Enterprise digital asset management (DAM)",
      style: "darkGradient",
      subtitle:
        "Advanced security and flexible controls that allow you to share your brand with your entire organization and the outside world",
      image: {
        src: Images.Enterprise.hero,
        alt: "",
      },
      primaryButton: MarketingButtons.contactSales,
      secondaryButton: MarketingButtons.bookDemo,
      position: { mb: "none", pb: "200" },
    },
    { type: "CustomerLogosSection", position: { mt: "-xxl" } },
    {
      type: "MediaSection",
      title: "Org - wide consistency ",
      subtitle:
        "Create a brand hub where everyone on your team can find the content and guidelines needed to create on brand experiences. ",
      image: {
        src: Images.Enterprise.consistency,
        alt: "Slide 1",
      },
      body: {
        style: "iconList",
        items: [
          {
            title: "Public and private access ",
            body: "Easily publish kits to your brand portal. Make them public, private or password protected.",
          },
          {
            title: "Custom domains",
            body: "Create an on brand link to your library to make it feel official and easy for team members to remember.",
          },
          {
            title: "Advanced custom branding",
            body: "Your brand. Your product. Choose a custom font, accent color and theme to make things feel official and on-brand.",
          },
        ],
      },
    },
    {
      type: "MediaSection",
      title: "Security you can count on",
      subtitle: "Keep your data safe with enterprise grade features and security audits",
      image: {
        src: Images.Enterprise.security,
        alt: "Slide 1",
      },
      layoutDirection: "image-left",
      body: {
        style: "iconList",
        items: [
          {
            title: "SSO",
            body: "Simplify secure access to your brand assets with SAML-based SSO. You can also manage employees at scale with SCIM provisioning.",
          },
          {
            title: "SOC - 2",
            body: "Lingo is SOC - 2 certified. See our full [trust report](https://trust-report.lingoapp.com).",
          },
          {
            title: "Custom controls",
            body: "Control granular details on your metadata and individual asset links",
          },
        ],
      },
    },
    {
      type: "MediaSection",
      title: "Support you can trust",
      subtitle:
        "Our world class support team is always ready to lend a hand and set your team up for sucess.",
      image: {
        src: Images.Enterprise.support,
        alt: "Slide 1",
      },
      body: {
        style: "iconList",
        items: [
          {
            title: "Batch importing",
            body: "Already have your assets on another platform? Our team will help you batch import your assets. ",
          },
          {
            title: "Priority support.",
            body: "Get answers to your questions in minutes not hours ",
          },
        ],
      },
    },
    {
      type: "FaqSection",
      title: "DAMs for Enterprise FAQ",
      faqs: [
        {
          question: "How does Lingo support enterprise security and compliance requirements?",
          answer:
            "Lingo is SOC2 compliant and offers enterprise-grade security features, including SSO-based user provisioning, role-based access controls, and audit logs. We also support custom MSAs and purchase orders to align with your organization’s compliance needs.",
        },
        {
          question: "Can we integrate Lingo with our existing tools and workflows?",
          answer:
            "Yes! Lingo integrates with Canva, Figma, Google Drive, Dropbox, and other key platforms, ensuring your teams can access and update assets without disrupting existing workflows. Our API also allows for deeper custom integrations.",
        },
        {
          question: "How does Lingo help ensure brand consistency across global teams?",
          answer:
            "Lingo centralizes brand guidelines and digital assets in one searchable hub, ensuring every team, whether marketing, product, or sales, uses the latest, approved content. Built-in governance tools like metadata tagging, version control, and usage tracking prevent outdated or off-brand assets from being used.",
        },
        {
          question:
            "How does Lingo handle permissions and access control across different teams and external partners?",
          answer:
            "Lingo allows for granular permission settings, letting admins manage access at the kit, folder, or user level. You can create public, private, or password-protected links for internal teams, agencies, and external partners while maintaining full oversight over asset usage.",
        },
        {
          question:
            "What makes Lingo a better choice for enterprise companies compared to other DAM providers?",
          answer:
            "Many DAM solutions are bloated and complex, requiring months of implementation. Lingo offers enterprise-level capabilities, like compliance, security, and integrations, without the unnecessary overhead, making it easier to deploy, scale, and maintain across large organizations.",
        },
      ],
    },
    {
      type: "ShowcaseSection",
      title: "Showcase your brand in Lingo",
      image: {
        src: Images.Home.showcase,
        alt: "Slide 1",
      },
    },
  ],
};
export default content;
